var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.82 12.5c.553 0 1 .448 1 1l.001 1.66c1.095.342 2.084.92 2.909 1.672l1.455-.835c.477-.274 1.086-.11 1.363.365l1.316 2.268c.277.477.115 1.09-.363 1.366l-.004.003-1.445.83c.12.538.183 1.097.183 1.671 0 .574-.063 1.133-.183 1.672l1.445.83c.48.274.644.885.37 1.364l-.003.004-1.316 2.268c-.277.476-.886.639-1.363.365l-1.455-.835c-.825.753-1.814 1.33-2.909 1.672v1.66c0 .552-.448 1-1 1H21.18c-.553 0-1-.448-1-1l-.001-1.66c-1.095-.342-2.084-.92-2.909-1.672l-1.455.835c-.477.274-1.086.11-1.363-.365l-1.316-2.268c-.277-.477-.115-1.09.363-1.366l.004-.003 1.445-.83c-.12-.538-.183-1.097-.183-1.671 0-.574.063-1.133.183-1.672l-1.445-.83c-.48-.274-.644-.885-.37-1.364l.003-.004 1.316-2.268c.277-.476.886-.639 1.363-.365l1.455.835c.825-.753 1.814-1.33 2.909-1.672V13.5c0-.552.448-1 1-1h2.641zm-1.32 7c-1.668 0-3.02 1.343-3.02 3s1.352 3 3.02 3 3.02-1.343 3.02-3-1.352-3-3.02-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.a635a1e7.svg";
export { ForwardRef as ReactComponent };